import React from "react";
import Popup from "devextreme-react/popup";
const AddSeedLotDialog = (props) => {
  const { openSeedLot, closeAddSeedLotDialog } = props;
  return (
    <div>
      <Popup
        visible={openSeedLot}
        onHiding={closeAddSeedLotDialog}
        showCloseButton={false}
        dragEnabled={false}
        closeOnOutsideClick={true}
        title="Add Seed Lot"
        width="auto"
        height="auto"
        toolbarItems={[
          {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: {
              text: "Ok",
              onClick: closeAddSeedLotDialog,
              stylingMode: "contained",
              type: "default",
              elementAttr: {
                class: "accordianButton",
              }
            },
          },
        ]}
      >
        <h5 className="font-weight-bold">
          Your new seed lot has been successfully added.
        </h5>
      </Popup>
    </div>
  );
};

export default AddSeedLotDialog;
